import { asyncMap } from './utils';
var uploadinator = function uploadinator(blobs$, options) {
  var upload = function upload(blob) {
    return options.uploader(blob).then(function () {
      return blob;
    });
  };
  return blobs$.pipe(asyncMap(upload, options.concurrency));
};
export { uploadinator };